document.addEventListener("alpine:init", () => {
  // ! START
  Alpine.data("store", () => ({
    dbg: true,
    groupId: prefs.groupId,
    loading: false,
    pageReady: false,
    processing: false,
    parentUrl: prefs.parentUrl,
    hashProduct: prefs.hashProduct, // product selected by default
    store: prefs.store,
    seller: prefs.seller,
    gridView: prefs.gridView,
    gridLines: prefs.gridLines,
    modal: false,
    listView: prefs.listView,
    quickAdd: prefs.quickAdd,
    viewcart: prefs.viewcart,
    thumbTitles: prefs.thumbTitles,
    thumbPrice: prefs.thumbPrice,
    thumbAlign: prefs.thumbAlign,
    thumbImgshadow: prefs.thumbImgShadow,
    thumbAddtocart: prefs.thumbAddtocart,
    thumbPagelink: prefs.thumbPagelink,
    catalogMode: prefs.catalogMode,
    sortBy: prefs.sortBy,
    search: prefs.search,
    categories: prefs.categories,
    categoryMenuOpen: false,
    cid: prefs.cid,
    cartUrl: prefs.cartUrl,
    page: prefs.page,
    mobileopen: false,
    showErrors: false,
    errorMessage: "",
    showingDetail: false,
    detailMarkup: "",
    currency: prefs.currency,
    products: prefs.products,
    filter: "",
    details: document.getElementById("product-details"),
    isIframedContent: false,

    init() {
      this.debug("Group Embed Initiated");
      // if self == top, then we are not in iframe.
      if (self == top) document.body.id = "cartloom-direct";
      isIframedContent = document.body.id === "cartloom-framed";
      this.pageReady = true;

      // how we load hashProduct if present
      if (this.hashProduct) {
        this.$nextTick(() => {
          this.showProductDetails(this.hashProduct);
        });
      }
    },
    // !debug
    debug(s) {
      if (this.dbg) if (window.console && window.console.log) window.console.log("[cartloom-group-embed] " + s);
    },
    // !logError
    logError(str) {
      Bugsnag.notify(new Error(str));
      if (window.console && window.console.log && str)
        window.console.error("[cartloom-group-embed] \n" + str.replace(/\t/g, "").trim());
    },
    // !showProductDetails
    async showProductDetails(slug) {
      this.searchVisible = false;
      if (isIframedContent) {
        var bodyElement = document.querySelector("body");
        var selector = bodyElement.dataset.selector;
        var data = { command: "scrollTopParentiFrame", selector: selector };
        window.parent.postMessage(JSON.stringify(data), "*");
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" }); // loaded direct
      }
      this.showingDetail = true;
      this.detailItem = null; // dump previous product
      this.details.innerHTML = "";
      this.loading = true;
      this.debug("Show details for slug = " + slug);
      // fetch the product data and present using template
      await fetch(this.cartUrl + "v5/embed/item-details/" + encodeURIComponent(slug), {
        method: "POST",
        body: JSON.stringify({
          slug: slug,
          group_id: this.groupId,
          parent_url: this.parentUrl,
        })
      })
        .then((response) => response.json())
        .then((data) => {
          //this.detailMarkup = data.markup
          setTimeout(() => {
            this.details.innerHTML = data.markup;
            this.loading = false;
            this.showingDetail = true;
            this.sendSizetoParentiFrame();
          }, 1000);
        })
        .then(() => {
          // this.showingDetail = true;
          // this.sendSizetoParentiFrame();
        })
        .catch((err) => this.logError("showProductDetails: Request Failed", err)); // Catch errors;
    },
    // !goBack
    goBack() {
      this.showingDetail = false;
      this.detailMarkup = "";
      this.sendSizetoParentiFrame();
    },
    // ! SHOW ADDTOCART BUTTON ?
    showAddToCartButton(product) {
      if (product.watch_inventory && !product.has_inventory && !this.catalogMode) {
        this.debug("addtocart - false");
        return false;
      }

      if (!product.has_spinoffs && !product.has_options && !this.catalogMode) {
        this.debug("addtocart - true");
        return true;
      }

      return false;
    },
    // ! showCart
    showCart() {
      this.debug("showCart");
    },
    // !searchProducts
    searchProducts() {
      this.debug("performing search...");
      this.searchLoader = true;

      fetch(this.cartUrl + "/v5/embed/ajax-search/" + encodeURIComponent(this.searchKeyword))
        .then((response) => response.json())
        .then((data) => {
          this.searchResults = data.items;
          this.searchLoader = false;
        })
        .then((this.searchVisible = true))
        //.then( this.searchLoader = false )
        .catch((err) => this.logError("Request Failed", err)); // Catch errors;
    },
    // !searchFound
    get searchFound() {
      return this.searchResults.length;
    },
    get searchFound() {
      return this.searchResults.length;
    },
    get filteredProducts() {
      return this.products.filter((item) => {
        this.sendSizetoParentiFrame();
        return (item.name + item.category + item.price).toLowerCase().includes(this.filter.toLowerCase());
      });
    },
    // !Utilites
    objExists(obj) {
      if (obj != undefined && obj != null && obj.length !== 0) return true;

      return false;
    },
    sendSizetoParentiFrame() {
      this.debug("sendSizetoParentiFrame called");
      var body = document.querySelector("body");
      var w = Math.max(body.offsetWidth, body.clientWidth);
      // get height and send back to adjust parent iframe
      setTimeout(() => {
        var height = Math.max(body.offsetHeight, document.body.clientHeight);
        var width = Math.max(body.offsetWidth, body.clientWidth);
        var selector = body.dataset.selector;

        // Jitter conditions and fixes
        w < 505 && w > 490 ? body.classList.add("passVH") : body.classList.remove("passVH");
        //$('body').hasScrollBar() ? $('body').addClass('passY') : $('body').removeClass('passY');

        var data = { command: "resizeParentiFrame", height: height, selector: selector };

        window.parent.postMessage(JSON.stringify(data), "*");
      }, 100); // use timeout to give it time to fully load before getting height.
    },
  }));
});
